export default {root:'m-77c9d27d',inner:'m-80f1301b',label:'m-811560b9',section:'m-a74036a',loader:'m-a25b86ee',group:'m-80d6d844'};